/**
 * A global namespace for `hover` event.
 * @type {string}
 */
const mousehoverEvent = 'hover';
export default mousehoverEvent;
